<template>
  <el-drawer
  :title="$t('carousel.addTitle')"
  :visible.sync="visible"
  :wrapperClosable="false"
  :direction="direction"
  :before-close="close"
  :size="width"
  @open="open">
  <div class="drawer__content scrollable only-y" :style="divHeight"   v-loading="fullScreenLoading">
    <el-form ref="form" :model="model" :rules="rules">
      <el-descriptions :title="$t('carousel.groupTitle')" :border="true" class="mb-20 mt-60"  :column="1">
         <el-descriptions-item :label="$t('carousel.selectFromExistantGroup')">
          <el-select v-model="model.selectedGroup" placeholder="Select" :disabled="model.newGroup === true" @change="handleChangeGroup" value-key="group">
            <el-option
              v-for="item in groups"
              :key="item.group"
              :label="groupName(item)"
              :value="item">
            </el-option>
          </el-select>
         </el-descriptions-item>
         <el-descriptions-item :label="$t('carousel.createNewGroup')">
          <el-switch
            @change="handleNewGroupe"
            v-model="model.newGroup"
            :disabled="numberOfExistedGroup == 0"
            active-color="#13ce66"
            inactive-color="#ff4949">
          </el-switch>
         </el-descriptions-item>
          <el-descriptions-item :label="$t('carousel.groupCode')" v-if="model.newGroup">
            <el-form-item prop="group">
              <el-input v-model="model.group" ></el-input>
            </el-form-item>
          </el-descriptions-item>
          <el-descriptions-item :label="$t('carousel.frenchGroupName')" v-if="model.newGroup">
            <el-form-item prop="groupNameFr">
              <el-input v-model="model.groupNameFr" ></el-input>
            </el-form-item>
          </el-descriptions-item>
          <el-descriptions-item :label="$t('carousel.englishGroupName')" v-if="model.newGroup">
            <el-form-item prop="groupNameEn">
              <el-input v-model="model.groupNameEn"></el-input>
            </el-form-item>
          </el-descriptions-item>
      </el-descriptions>
      <el-descriptions :title="$t('carousel.configurationTitle')" :border="true" class="mb-20" :column="1">
        <el-descriptions-item :label="$t('carousel.frenchName')">
          <el-form-item prop="nameFr">
            <el-input v-model="model.nameFr"></el-input>
          </el-form-item>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('carousel.englishName')">
          <el-form-item prop="nameFr"> 
            <el-input v-model="model.nameEn"></el-input>
          </el-form-item>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('carousel.publicationState')"> 
          <el-switch
            v-model="model.published"
            active-color="#13ce66"
            inactive-color="#ff4949">
          </el-switch>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('carousel.interval')">
          <el-input-number v-model="model.interval" controls-position="right"></el-input-number>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('carousel.randomMode')"> 
          <el-switch
            v-model="model.random"
            active-color="#13ce66"
            inactive-color="#ff4949">
          </el-switch>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('carousel.type')">
          <el-select v-model="model.type" placeholder="Select" default-first-option>
            <el-option
              v-for="item in types"
              :key="item"
              :label="$t('carousel.types.'+item)"
              :value="item">
            </el-option>
          </el-select>
        </el-descriptions-item>
      </el-descriptions>
    </el-form>
    <div class="dialog-footer card-shadow--large">
      <el-button @click="close">{{$t('common.Cancel')}}</el-button>
      <el-button @click="save">{{$t('common.save')}}</el-button>
    </div>
</div>
</el-drawer>
</template>
<script>

import cmsAPI from '@/services/API/cmsAPI';

export default {
  name: 'carousel-drawer',
	props: {
		visible : Boolean,
    direction : {
      type : String,
      default : "rtl" //rtl / ltr / ttb / tbb
    },
    groups: []
	},
  data() {
    return {
      model : {
        nameFr : null,
        nameEn: null,
        newGroup: false,
        groupNameFr: null,
        groupNameEn: null,
        interval: 1000,
        random: false,
        published: true,
        type: 'PRODUCT-INVENTORY',
        group: null,
        selectedGroup: null,
      },
      types: ['PRODUCT-INVENTORY'],
      fullScreenLoading : false,
      window: {
        width: 0,
        height: 0
      },
      rules : {
        group : [
          { required: true, message: this.$i18n.t('carousel.groupMandatoryInstruction'), trigger: 'blur' }
        ],
        groupNameFr : [
          { required: true, message: this.$i18n.t('carousel.groupNameFrMandatoryInstruction'), trigger: 'blur' }
        ],
        groupNameEn : [
          { required: true, message: this.$i18n.t('carousel.groupNameEnMandatoryInstruction'), trigger: 'blur' }
        ],
        nameFr : [
          { required: true, message: this.$i18n.t('carousel.nameFrMandatoryInstruction'), trigger: 'blur' }
        ],
        nameEn : [
          { required: true, message: this.$i18n.t('carousel.nameEnMandatoryInstruction'), trigger: 'blur' }
        ]
      }
    };
  },components: {

  },
	methods: {
    handleNewGroupe(value) {
      if (value) {
        this.model.groupNameFr = null;
        this.model.groupNameEn = null;
        this.model.group = null;
      } else {
        if (this.model.selectedGroup != null) {
          this.handleChangeGroup(this.model.selectedGroup);
        } else {
          this.handleChangeGroup(_.head(this.groups));
          this.model.selectedGroup = _.head(this.groups);
        }
        
      }
      
    },
    groupName (group) {
      const locale =  this.$i18n.locale;
      if (locale === 'fr') {
        return group.groupNameFr;
      } else {
        return group.groupNameEn;
      }
    },
    open (){
      if (this.numberOfExistedGroup ==0) {
        this.model.newGroup = true;
      } else {
        this.handleChangeGroup(_.head(this.groups));
        this.model.selectedGroup = _.head(this.groups);
      }
    },
    reset () {
      this.model.nameFr = null;
      this.model.nameEn = null;
      this.model.groupNameFr = null;
      this.model.groupNameEn = null;
      this.model.interval = 1000;
      this.model.random = false;
      this.model.published = true;
      this.model.type = 'PRODUCT-INVENTORY';
      this.model.newGroup = false;
      this.model.group = null;
    },
    close () {
      this.$emit('close');
      this.reset();
    },
    handleChangeGroup (group) {
      this.model.groupNameFr = group.groupNameFr;
      this.model.groupNameEn = group.groupNameEn;
      this.model.group = group.group;
    },
    save () {
      return this.$refs['form'].validate()
        .then(() => {
          const postInfo = {
          group: this.model.group,
          groupNameFr: this.model.groupNameFr,
          groupNameEn: this.model.groupNameEn,
          interval: this.model.interval,
          configuration: {
            type: this.model.type,
            contents: [],
          },
          type: this.model.type,
          published: this.model.published,
          random: this.model.random,
          languages: [
            {
              id: 1,
              name: this.model.nameFr,
            },
            {
              id: 2,
              name: this.model.nameEn,
            }
          ]
        }

        cmsAPI.saveCarousel(postInfo)
          .then((carousel) => {
            this.$emit('add', carousel);
            this.$emit('close');
            this.reset();
          })
          .catch((err) => {
            console.log(err);
          })
        })
        .catch(() => {
          this.$message.warning(this.$i18n.t('common.formIncomplete'));
        })
      
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
	},
	computed: {  
    numberOfExistedGroup () {
      return _.size(this.groups);
    },  
    divHeight(){
      return "height :"+ (this.window.height-140) + "px"
    },
    width(){
      if(this.window.width > 1024){
        return "50%";
      }else{
        return "100%"
      }
    },
	},
  created(){
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
<style lang="scss" scoped>
.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:50px;
  margin-left:-40px;
  padding-left:40px;
  padding-top:10px;
  border-top:1px solid #E4E7ED
}

.drawer__content {
  margin-left:40px;
  margin-right:20px;
}

@media (max-width: 1366px) {
  .formContainer{
      margin-left:10%;
      width:80%;
    }
}

@media (max-width: 1024px) {
  .formContainer{
      margin-left:2%;
      width:98%;
    }
}

</style>
